// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddToCreatorCheckbox {
  position: absolute;
  left: 0;
  top: 0;
}
.AddToCreatorCheckbox [class*=dist_tooltipped] {
  width: 24px;
  height: 30px;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/components/CreatorCard/components/AddToCreatorCheckbox/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AACJ","sourcesContent":[".AddToCreatorCheckbox {\n  position: absolute;\n  left: 0;\n  top: 0;\n\n  [class*='dist_tooltipped'] {\n    width: 24px;\n    height: 30px;\n    position: absolute;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
